// extracted by mini-css-extract-plugin
module.exports = {"Input":"PublicInfoForm_Input__2EB6T","SmallInput":"PublicInfoForm_SmallInput__36QvA","Errors":"PublicInfoForm_Errors__1ns3X","LogoSection":"PublicInfoForm_LogoSection__8eoYo"};